import "../../index.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getAllInvitation,
  postFormReview,
  postImageTracker,
} from "../../Store/Action";
import { Copy, X, Link, CheckCircle, BookText } from "lucide-react";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";
import Modalracking from "./TrackingImageGuideline ";

const showErrorWithGuideButton = (setShowGuideline) => {
  Swal.fire({
    icon: "error",
    title: "잘못된 URL",
    html: `
      <p class="text-sm">리뷰배너가 누락되었습니다.<br />리뷰 배너 등록방법을 참고해주세요</p>
      <button id="open-guideline" class="mt-4 px-4 py-2 rounded-full border border-[#46B6D0] text-[#46B6D0] text-sm hover:bg-[#46B6D0] hover:text-white transition">
        리뷰배너 등록방법
      </button>
    `,
    showConfirmButton: true,
    confirmButtonText: "확인",
    customClass: {
      confirmButton:
        "bg-red-500 hover:bg-[#0d1a5f] text-white py-3 px-10 rounded-full",
      popup: "rounded-lg shadow-lg text-sm",
    },
    didOpen: () => {
      const button = document.getElementById("open-guideline");
      if (button) {
        button.addEventListener("click", () => {
          Swal.close(); // Tutup swal
          setTimeout(() => {
            setShowGuideline(true); // Buka modal setelah swal ditutup
          }, 300);
        });
      }
    },
  });
};

// 통일된 알림 헬퍼들
const showSuccess = (text, title = "성공") =>
  Swal.fire({
    title,
    text,
    icon: "success",
    confirmButtonText: "확인",
    buttonsStyling: false,
    customClass: {
      confirmButton:
        "bg-[#0F1E6C] hover:bg-[#0d1a5f] text-white py-3 px-10 rounded-full",
      popup: "rounded-lg shadow-lg text-sm mx-auto",
    },
  });

const showError = (title, text) =>
  Swal.fire({
    icon: "error",
    title,
    text,
    confirmButtonText: "확인",
    buttonsStyling: false,
    customClass: {
      confirmButton:
        "bg-red-500 hover:bg-[#0d1a5f] text-white py-3 px-10 rounded-full",
      popup: "rounded-lg shadow-lg text-sm",
    },
  });

const showAuthRequired = () =>
  Swal.fire({
    icon: "warning",
    title: "로그인이 필요합니다",
    text: "인증이 만료되었습니다. 다시 로그인해주세요.",
    confirmButtonText: "로그인으로 이동",
    buttonsStyling: false,
    customClass: {
      confirmButton:
        "bg-[#0F1E6C] hover:bg-[#0d1a5f] text-white py-3 px-10 rounded-full",
      popup: "rounded-lg shadow-lg text-sm",
    },
  });

function ListInvitationDetail({ open, el, setShowModals, setActiveTab }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    blog_url: "",
    unique_code: "",
    subscription_id: el.id,
    user_id: 0,
  });

  const [imageTracker, setImageTracker] = useState({
    unique_code: "",
    subscription_id: el.id,
    user_id: 0,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [imageTracking, setImageTracking] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [showGuideline, setShowGuideline] = useState(false);
  const handleGuidelineOpen = () => setShowGuideline(true);
  const handleGuidelineClose = () => setShowGuideline(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (el) {
      dispatch(getAllInvitation());
    }
  }, [dispatch, el]);

  const displayedKeywords = useMemo(() => {
    const keywords = el?.keyword || "";
    const keywordArray = keywords
      .split(/[#|,]/)
      .map((word) => word.trim())
      .filter((word) => word !== "");
    return keywordArray.slice(0, 6);
  }, [el?.keyword]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // 응답 코드에 따른 결과 처리 분리
  const handleReviewResult = (result) => {
    const code = result?.meta?.code;
    const apiMessage = result?.meta?.message;

    switch (code) {
      case 200:
        showSuccess("리뷰 등록이 성공적으로 완료되었습니다!");
        setIsSubmitted(true);
        setShowModals(false);
        setActiveTab("finish");
        navigate("/mypage");
        break;
      case 409:
        showError("등록 불가", apiMessage || "이미 리뷰가 등록되었습니다.");
        break;
      case 400:
      case 422:
        showErrorWithGuideButton(setShowGuideline);
        break;
      case 503:
        showError(
          "일시적 오류",
          apiMessage || "서버가 바쁩니다. 잠시 후 다시 시도해주세요."
        );
        break;
      //     	// Crawler errors [451xx]
      // ErrCrawlerTitleDoesNotContainKeywords = New(fiber.StatusBadRequest, 45101, "Review title does not contain keywords")
      // ErrCrawlerInsufficientCharacters      = New(fiber.StatusBadRequest, 45102, "Review content has insufficient characters")
      // ErrCrawlerInsufficientImages          = New(fiber.StatusBadRequest, 45103, "Review content has insufficient images")
      // ErrCrawlerFetchFailed                 = New(fiber.StatusBadRequest, 45104, "Failed to fetch content from URL")

      case 45101:
        showError(
          "리뷰 등록 실패",
          "리뷰 제목에 필수 키워드가 포함되어 있지 않습니다. 제공된 키워드를 제목에 포함해 주세요."
        );
        break;
      case 45102:
        showError(
          "리뷰 등록 실패",
          "리뷰 내용이 부족합니다. 최소 1500자 이상 작성해주세요."
        );
        break;
      case 45103:
        showError(
          "리뷰 등록 실패",
          "리뷰에 포함된 이미지가 부족합니다. 이미지를 추가해 주세요."
        );
        break;
      case 45104:
        showError(
          "리뷰 등록 실패",
          "제공하신 URL의 콘텐츠를 가져오지 못했습니다. URL을 확인하거나 잠시 후 다시 시도해 주세요."
        );
        break;
      case 401:
        showAuthRequired().then(() => navigate("/login"));
        break;
      default:
        showError("리뷰 등록 실패", apiMessage || "잠시 후 다시 시도해주세요.");
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsloading(true);
      const result = await dispatch(postFormReview(formData));
      handleReviewResult(result);
    } catch (error) {
      console.error("리뷰 등록 실패:", error);
      // 네트워크/HTTP 오류 등(throw 된 경우)
      const message = error?.message || "오류가 발생했습니다.";
      if (
        message.includes("인증") ||
        message.toLowerCase().includes("session") ||
        message.toLowerCase().includes("expired")
      ) {
        showAuthRequired().then(() => navigate("/login"));
      } else {
        showErrorWithGuideButton(setShowGuideline);
      }
    } finally {
      setIsloading(false);
    }

    // try {
    //   const result = await dispatch(postFormReview(formData));
    //   if (result) {
    //     setIsSubmitted(true);
    //     alert("리뷰 등록이 성공적으로 완료되었습니다!");
    //     setShowModals(false);
    //     setActiveTab("finish");
    //     navigate("/mypage");
    //   } else {
    //     alert("리뷰 등록에 실패했습니다. 다시 시도해주세요.");
    //   }
    // } catch (error) {
    //   console.error("Error in handleSubmit:", error);
    //   alert(
    //     "협찬링크가 첨부되지 않았습니다. 링크 이미지 생성 버튼을 눌러 배너이미지를 블로그에 등록후 리뷰등록을 진행해주세요!"
    //   );
    // }
  };

  const copyToClipboard = async (text) => {
    setCopySuccess(false);
    try {
      // 표준 Clipboard API 시도
      await navigator.clipboard.writeText(text);
      setCopySuccess(true);
      return true;
    } catch (err) {
      // Clipboard API 실패 시 대체 방법으로 시도
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);
        if (successful) {
          setCopySuccess(true);
          return true;
        }
      } catch (err2) {
        console.error("클립보드 복사 실패:", err2);
      }
    }
    return false;
  };

  const handleImageTrackerClick = async () => {
    try {
      const result = await dispatch(postImageTracker(imageTracker));

      if (result?.data && result?.data?.image_tracking) {
        setImageTracking(result.data.image_tracking);

        // 이미지 URL이 생성되자마자 복사 시도
        const copied = await copyToClipboard(result.data.image_tracking);

        if (copied) {
          alert("이미지 URL이 생성되어 클립보드에 복사되었습니다.");
        } else {
          alert(
            "이미지 URL이 생성되었지만 자동 복사에 실패했습니다. 수동으로 복사해주세요."
          );
        }
      } else {
        console.error("Invalid response from API:", result);
        alert("이미지 URL 생성에 실패했습니다. 다시 시도해주세요.");
      }
    } catch (error) {
      console.error("Error in handleImageTrackerClick:", error);
      alert("이미지 URL 생성 중 오류가 발생했습니다.");
    }
  };

  const handleClose = () => {
    setShowModals(false);
  };

  // 추가 복사 기능 - URL 표시 영역에서 재복사할 때 사용
  const handleManualCopy = () => {
    copyToClipboard(imageTracking);
    alert("이미지 URL이 다시 복사되었습니다.");
  };

  return open ? (
    <div className="fixed inset-0 flex items-center justify-center text-left bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-md relative w-full mx-4">
        <div className="justify-end flex pt-4 pr-4">
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-lg">
          <div className="px-4 pb-6 lg:px-8 lg:mx-auto lg:pt-5">
            <div className="flex flex-col gap-2">
              <div className="flex flex-col w-full">
                <h1 className="font-extrabold text-lg text-center pb-1">
                  리뷰등록하기
                </h1>
              </div>
              <hr />
            </div>

            <div className="flex flex-col gap-2 mt-6">
              <h1 className="font-extrabold">키워드</h1>
              <div className="flex flex-wrap gap-2">
                {displayedKeywords?.map((word, index) => (
                  <div
                    key={index}
                    className="py-1 rounded-full border px-3 bg-[#EEEEEE] text-sm"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-2 mt-6">
              <h1 className="font-extrabold">리뷰배너</h1>
              <button
                type="button"
                onClick={handleImageTrackerClick}
                disabled={isSubmitted}
                className={`${
                  isSubmitted
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#46B6D0] hover:bg-[#3a9db5]"
                } flex items-center justify-center gap-2 text-white py-2 px-4 rounded-full text-sm transition-colors`}
              >
                <Link size={18} />
                {isSubmitted ? "이미지 생성 완료" : "링크 이미지 생성"}
              </button>

              {imageTracking && (
                <div className="mt-4 p-3 bg-gray-50 rounded-lg border">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-sm text-gray-700">생성된 URL:</p>
                    <div className="flex items-center text-xs text-green-600">
                      {copySuccess && (
                        <>
                          <CheckCircle size={14} className="mr-1" />
                          <span>복사됨</span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="text"
                      value={imageTracking}
                      readOnly
                      className="w-full border bg-white px-3 h-10 rounded-l-md text-sm focus:outline-none"
                    />
                    <button
                      onClick={handleManualCopy}
                      className="bg-[#46B6D0] hover:bg-[#3a9db5] h-10 text-white px-3 py-2 rounded-r-md transition-colors"
                    >
                      <Copy size={16} />
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2 mt-6">
              <div className="flex justify-between">
                <p className="font-bold">리뷰주소</p>
                <div
                  onClick={handleGuidelineOpen}
                  className="flex gap-1 items-center text-[#46B6D0] hover:text-[#3a9db5] text-xs rounded-full border border-[#46B6D0] px-2 py-1"
                >
                  <BookText className="w-4 h-4" />
                  <div className="">리뷰배너 등록방법</div>
                </div>
              </div>
              <p className="text-xs text-red-500 pb-1">
                *필수 키워드 등록 확인 및 리뷰배너 상단 설치 후 리뷰를
                등록해주세요.
              </p>
              <input
                type="text"
                name="blog_url"
                value={formData.blog_url}
                onChange={handleChange}
                className="w-full border px-4 py-3 focus:outline-black rounded"
                placeholder="블로그 URL"
                disabled={isSubmitted}
                required
              />
            </div>

            <div className="flex flex-col gap-2 mt-6">
              <button
                className={`bg-[#0F1E6C] rounded-full text-white py-3 ${
                  isSubmitted
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-[#0d1a5f]"
                } transition-colors`}
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? <ClipLoader color="#fff" size={20} /> : "등록하기"}
              </button>
            </div>
          </div>
        </form>
      </div>
      {showGuideline && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full relative mx-4">
            <button
              onClick={handleGuidelineClose}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 p-2"
            >
              <X size={20} />
            </button>
            <Modalracking />
          </div>
        </div>
      )}
    </div>
  ) : null;
}

export default ListInvitationDetail;
